module.exports = __webpack_public_path__ + "img/logo.f6e5674e.png";